import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 0C2.89543 0 2 0.89543 2 2C2 3.10457 2.89543 4 4 4C5.10457 4 6 3.10457 6 2C6 0.89543 5.10457 0 4 0Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 0C9.89543 0 9 0.89543 9 2C9 3.10457 9.89543 4 11 4C12.1046 4 13 3.10457 13 2C13 0.895431 12.1046 0 11 0Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 0C16.8954 0 16 0.895431 16 2C16 3.10457 16.8954 4 18 4C19.1046 4 20 3.10457 20 2C20 0.895431 19.1046 0 18 0Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 6C16.8954 6 16 6.89543 16 8C16 9.10457 16.8954 10 18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9999 5.31104C9.75169 5.31104 8.73986 6.32287 8.73986 7.57104V15.6347L6.06333 15.1059C5.31798 14.9587 4.55733 15.2749 4.13607 15.9072L3.18652 17.3324L7.48485 22.9236C8.00666 23.6024 8.81424 24.0002 9.67042 24.0002H16.7559C17.9427 24.0002 18.9963 23.2407 19.3714 22.1147L21.1538 16.7642C21.566 15.5267 21.0545 14.1696 19.928 13.5121L16.3033 11.3964C15.8816 11.1502 15.402 11.0205 14.9137 11.0205H13.2599V7.57104C13.2599 6.32287 12.248 5.31104 10.9999 5.31104Z"}}]};

const GestureTypingFilled = Vue.extend<IconProps>({
  name: 'GestureTypingFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-typing-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureTypingFilled;
